import React from 'react';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { TastesLikeHomeShef } from './placeholderConsts';
import {
  BackgroundContainer,
  ImageContainer,
  ShefDetails,
  ShefName,
  StyledCategory,
  StyledContent,
  StyledDescription,
  StyledDishImage,
  StyledDishTitle,
  StyledPanelCard,
  StyledRow,
} from './styles';

interface IProps {
  content: TastesLikeHomeShef;
  onClick: () => void;
}

export const TastesLikeHomePanel: React.FC<IProps> = ({ content, onClick }) => (
  <StyledPanelCard onClick={onClick}>
    <ImageContainer>
      <BackgroundContainer backgroundImage={content.background}>
        <StyledDishImage src={content.dishImage} alt='' />
      </BackgroundContainer>
    </ImageContainer>
    <StyledContent>
      <div>
        <StyledRow>
          {content.categoryIllustrationUrl ? (
            <DynamicImage src={content.categoryIllustrationUrl} sourceHeight={40} height={40} />
          ) : (
            content.categoryIcon
          )}
          <StyledCategory>{content.category}</StyledCategory>
        </StyledRow>
        <StyledDishTitle>{content.dishName}</StyledDishTitle>
        <StyledDescription>{content.dishDescription}</StyledDescription>
      </div>
      <div>
        <StyledRow>
          <img src={content.shefPic} alt='' />
          <ShefDetails>
            <ShefName>Shef {content.shefName}</ShefName>
            <StyledDescription>{content.subcuisines.join(' ∙ ')}</StyledDescription>
          </ShefDetails>
        </StyledRow>
      </div>
    </StyledContent>
  </StyledPanelCard>
);
